
export class ReportTeamologyConfig {
    public id: number;
    public organizationID: number;
    public topLeft: string;
    public topRight: string;
    public bottomLeft: string;
    public bottomRight: string;
}


// WEBPACK FOOTER //
// ./src/models/ReportTeamologyConfig.tsx